import React from 'react';
import b_hecho_en_casa from '../images/b_hecho_en_casa.png';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import { Container, Card, Button, NavLink, Accordion } from 'react-bootstrap';
import avatar_motobombas from "../images/avatar_motobombas.png";
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css'; // Importar los estilos de Leaflet

const Bcontacto = () => {
  return (
    <Card style={{ width: 'w-100', backgroundColor: '#2D4E76' }}>
      <Card.Img variant="top" src={b_hecho_en_casa} />
    </Card>
  );
};

const Acoredoncontacto = () => {
  const accordionItems = [
    {
      title: 'Oficina Principal',
      location: 'C. 93, Paraparal 2011, Carabobo',
      email: 'motoredes2021@gmail.com',
      phone: '(0245)-4154042',
      positionComponent: <Position1 />,
    },
    {
      title: 'Sucursal Oriente',
      location: 'San José de Guanipa 6050, Anzoátegui',
      email: 'motoredes2021@gmail.com',
      phone: '(0283)-4002563',
      positionComponent: <Position2 />,
    },
  ];

  return (
    <Accordion defaultActiveKey="0">
      {accordionItems.map((item, index) => (
        <Accordion.Item key={index} eventKey={index.toString()}>
          <Accordion.Header style={{ backgroundColor: '#2D4E76', color: 'white' }}>
            {item.title}
          </Accordion.Header>
          <Accordion.Body>
            <p>Ubicación: {item.location}</p>
            <p>Correo Electrónico: {item.email}</p>
            <p>Número Telefónico: {item.phone}</p>
            {item.positionComponent}
            {item.content}
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}

const Position1 = () => {
  const position = [10.198663094993979, -67.91776271928919];

  return (
    <MapContainer center={position} zoom={13} scrollWheelZoom={false} style={{ height: "400px", width: "100%" }}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={position}>
        <Popup>
          Oficina Principal. <br /> C. 93, Paraparal 2011, Carabobo.
        </Popup>
      </Marker>
    </MapContainer>
  );
};

const Position2 = () => {
  const position = [8.895010928558902, -64.1948971827525];

  return (
    <MapContainer center={position} zoom={13} scrollWheelZoom={false} style={{ height: "400px", width: "100%" }}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={position}>
        <Popup>
          Sucursal Oriente. <br /> San José de Guanipa 6050, Anzoátegui.
        </Popup>
      </Marker>
    </MapContainer>
  );
};

const Contactos = () => {
  const buttonStyle = {
    backgroundColor: '#2D4E76',
    borderColor: '#2D4E76', // Color del borde
  };

  return (
    <Container className="d-flex justify-content-center" style={{ marginTop: "auto" }}>
      <Button variant="light" className="m-2" style={buttonStyle}>
        <NavLink href="https://wa.me/584244024689">
          <WhatsAppIcon fontSize="large" style={{ color: '#FAFAFA' }} />
        </NavLink>
      </Button>
      <Button variant="light" className="m-2" style={buttonStyle}>
        <NavLink href="https://instagram.com/motobombasca?igshid=ZDc4ODBmNjlmNQ==">
          <InstagramIcon fontSize="large" style={{ color: '#FAFAFA' }} />
        </NavLink>
      </Button>
      <Button variant="light" className="m-2" style={buttonStyle}>
        <NavLink href="https://www.google.com/maps/place/Motobombas,+C.A.+Sede+Principal/@10.1984189,-67.9175419,17z/data=!3m1!4b1!4m6!3m5!1s0x8e80679603cd1def:0x897bd1f33654eda4!8m2!3d10.1984189!4d-67.9175419!16s%2Fg%2F11d_9hj8zl">
          <FmdGoodIcon fontSize="large" style={{ color: '#FAFAFA' }} />
        </NavLink>
      </Button>
    </Container>
  );
};


const Footer = () => {
  return (
    <div
      style={{
        marginTop: "auto", // Hace que el Footer siempre esté al final
        backgroundColor: '#2D4E76',
        color: "#FAFAFA",
        textAlign: "center",
        padding: "10px", // Puedes ajustar el padding según tus necesidades
      }}
    >
      © 2023 Motobombas C.A.
    </div>
  );
};

const Contacto = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", backgroundColor: "#2D4E76", minHeight: "100vh" }}>
      <Bcontacto />
      <Acoredoncontacto />
      <Contactos />
      <Footer />
      <FloatingWhatsApp
        phoneNumber="+584244024689"
        accountName="Motobombas,c.a."
        chatMessage="Hola!, Bienvenido a Motobombas,c.a. ¿Como podemos ayudarte? "
        avatar={avatar_motobombas}
        statusMessage="Fabricantes de Bombas de agua"
      />
    </div>
  );
};

export default Contacto;